var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef } from "react";
import { useSignal } from "@preact/signals";
import classNames from "classnames";
import Icon from "../../Icon";
import Button from "../../Button";
import style from "./style.module.scss";
export default function TextInput(props) {
    const { prefix, suffix, clearable, code, defaultValue, error, customClass, typeAheadOptions, typeAheadTitle } = props, inputProps = __rest(props, ["prefix", "suffix", "clearable", "code", "defaultValue", "error", "customClass", "typeAheadOptions", "typeAheadTitle"]);
    const inputValue = useSignal(defaultValue !== undefined ? String(defaultValue) : "");
    const relevantOptions = useSignal([]);
    const inputRef = useRef(null);
    const errorClass = error ? style["text-input--error"] : "";
    const codeClass = code ? style["text-input--code"] : "";
    //Show or hide the clearable icon depending on the content in the input.
    function onInput(event) {
        inputValue.value = event.currentTarget.value;
        if (props.onInput) {
            props.onInput(event);
        }
        if (typeAheadOptions) {
            updateTypeAhead();
        }
    }
    //Input value has been updated so display related type ahead options.
    function updateTypeAhead() {
        if (typeAheadOptions) {
            let exactMatch = false;
            const updatedRelevantOptions = typeAheadOptions.filter((option) => {
                const optionLowerCase = option.toLowerCase();
                if (optionLowerCase === inputValue.value.toLowerCase()) {
                    exactMatch = true;
                }
                return optionLowerCase.includes(inputValue.value.toLowerCase());
            });
            if (!exactMatch) {
                //We have some options that contain the currently entered input value so show the suggestions.
                relevantOptions.value = updatedRelevantOptions;
            }
            else {
                //We have a perfect match. No need to show the suggestions.
                relevantOptions.value = [];
            }
        }
    }
    //User wants to clear their input.
    function clearInput() {
        inputValue.value = "";
        if (inputRef.current) {
            inputRef.current.value = "";
            inputRef.current.dispatchEvent(new Event("input"));
        }
    }
    const typeAheadElements = [];
    relevantOptions.value.forEach((option) => {
        typeAheadElements.push(_jsx(Button, { variation: "none", onClick: () => {
                inputValue.value = option;
                updateTypeAhead();
                if (inputRef.current) {
                    inputRef.current.value = option;
                    inputRef.current.dispatchEvent(new Event("input"));
                }
            }, className: style["text-input__type-ahead-list__option-button"], children: _jsx("div", { className: style["text-input__type-ahead-list__option"], children: option }) }));
    });
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: classNames(style["text-input"], codeClass, errorClass, customClass), children: [prefix ? _jsx("div", { className: style["text-input__prefix"], children: prefix }) : null, _jsx("input", Object.assign({ type: "text", ref: inputRef, value: inputValue.value }, inputProps, { onInput: onInput })), suffix ? _jsx("div", { className: style["text-input__suffix"], children: suffix }) : null, clearable ? (_jsx(Button, { type: "button", variation: "none", className: classNames(style["text-input__clearable"], {
                            [style["text-input__clearable--active"]]: inputValue,
                        }), onClick: clearInput, children: _jsx(Icon, { name: "xmark--thin" }) })) : null] }), relevantOptions.value.length > 0 && (_jsx("div", { className: style["text-input__type-ahead-list__container"], children: _jsxs("div", { className: style["text-input__type-ahead-list"], children: [typeAheadTitle !== undefined && (_jsx("div", { className: style["text-input__type-ahead-list__title"], children: typeAheadTitle })), typeAheadElements] }) }))] }));
}
